import { GatsbyLinkProps as InternalGatsbyLinkProps, Link } from 'gatsby';
import * as React from 'react';
import { BoxOwnProps, Link as ThemeUILink } from 'theme-ui';

type GatsbyLinkProps = React.ComponentPropsWithRef<'a'> &
	BoxOwnProps &
	InternalGatsbyLinkProps<unknown>;

const GatsbyLink: React.FC<GatsbyLinkProps> = ({ ...props }) => (
	<ThemeUILink
		as={Link}
		activeClassName='active'
		sx={{ '&:hover': { textDecoration: 'underline' } }}
		{...props}
	/>
);

export default GatsbyLink;
